import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/services/data/data.service';
import { MapService } from 'src/app/services/map/map.service';
import { SplitViewService } from 'src/app/services/split-view/split-view.service';
import { LayerStoreService } from 'src/app/stores/layer-store/layer-store.service';
import { SplitViewComponent } from '../split-view/split-view.component';

const data = [
  { link: 'assets/images/annotation.png' },
  { link: 'assets/images/annotation.png' },
  { link: 'assets/images/annotation.png' },
  { link: 'assets/images/annotation.png' },
  { link: 'assets/images/annotation.png' },
  { link: 'assets/images/annotation.png' },
  { link: 'assets/images/annotation.png' },
  { link: 'assets/images/annotation.png' },
  { link: 'assets/images/annotation.png' },
  { link: 'assets/images/annotation.png' },
  { link: 'assets/images/annotation.png' },
  { link: 'assets/images/annotation.png' },
  { link: 'assets/images/annotation.png' },
  { link: 'assets/images/annotation.png' },
]

@Component({
  selector: 'app-card-xsmall',
  templateUrl: './card-xsmall.component.html',
  styleUrls: ['./card-xsmall.component.sass']
})
export class CardXsmallComponent implements OnInit {
  @Output() onSpotlightToggle: EventEmitter<boolean> = new EventEmitter()
  isSpotlight = false
  isThreeD = false
  favImages: any[]
  currentSlide: number = 0;
  isExpand

  // unsubber: Subject<boolean> = new Subject<boolean>();

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.hideGallery()
  }

  constructor(
    private dataService: DataService,
    private mapService: MapService,
    private layerStore: LayerStoreService,
    private splitViewService: SplitViewService,
  ) { }

  ngOnInit(): void {
    this.dataService.featureImages$.subscribe(favImages => {
      this.favImages = favImages
    })
    this.layerStore.isThreeD$.subscribe(res => this.isThreeD = res)
  }

  toggleSpotlight() {
    this.isSpotlight = !this.isSpotlight
    this.onSpotlightToggle.emit(this.isSpotlight)
    if (this.isSpotlight) {
      
      this.dataService.featureImages$
        // .pipe(takeUntil(this.unsubber.asObservable()))
        .subscribe(favImages => {
          if (favImages[0]) {
            const imageUrl = favImages.splice(0, 5).reduce((acc, i) => { return [...acc, `https://proxy.aerodyne.dev/${i.link}`] }, [])
            this.mapService.loadSpotlight3D(imageUrl);
          }
      })
      this.mapService.isSpotlightMode$.next(true);
    } else {
      // this.unsubber.next();
      // this.unsubber.unsubscribe();
      this.mapService.isSpotlightMode$.next(false);
      this.mapService.removeSpotlight3D()
    }
  }

  onNavCarousel(currentSlide: number) {
    // setTimeout(() => {
    
    // const offset = document.getElementById(`carouselThumbnail${currentSlide}`).offsetLeft
    // document.querySelector('.carousel-thumbnail').scrollTo({
    //   left: offset,
    //   behavior: 'smooth',
    // });
    this.currentSlide = currentSlide;
    // }, 500);
  }

  showCarousel(slideIndex) {
    this.isExpand = true
    this.currentSlide = slideIndex
  }

  hideGallery($event?) {
    // if (!this.isExpand) $event.preventDefault()
    this.isExpand = false
  }

  resetBearing() {
    this.mapService.map.easeTo({
      bearing: 0,
      easing: this._easing.bind(this)
    });
    this.splitViewService.onEvent$.next({ onClickResetBearing: true })
  }

  resetPitch() {
    this.mapService.map.easeTo({
      pitch: 0,
      easing: this._easing.bind(this)
    });
    this.splitViewService.onEvent$.next({ onClickResetPitch: true })
  }

  _easing(t) {
    return t * (2 - t);
  }

  closeCarousel() {
    this.dataService.featureImages$.next([])
    // this.unsubber.next();
    // this.unsubber.unsubscribe();
  }
}
